import { App } from '../../pkg';
import FPS from './fps';

interface Looper {
  fps: FPS;
  start: () => void;
}

export const makeLooper = (app: App): Looper => {
  const fps = new FPS();
  const loop = () => {
    fps.render();
    app.render();
    window.requestAnimationFrame(loop);
  };
  const looper = {
    fps,
    start: function () {
      window.requestAnimationFrame(loop);
    },
  };
  return looper;
};
